import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import style from './store-status-dropdown.module.less';
import messages from '../messages';

const ImportingStatus = () => (
  <div className={classnames(style['status-message'], style['status-importing'])}>
    <LoadingIndicator className={style['loading-indicator']} theme='grey' />
    <span>
      <FormattedMessage {...messages.storeStatusImporting} />
    </span>
  </div>
);

export default ImportingStatus;
